import { render, staticRenderFns } from "./CuponsList.vue?vue&type=template&id=d4a15e58&"
import script from "./CuponsList.vue?vue&type=script&lang=js&"
export * from "./CuponsList.vue?vue&type=script&lang=js&"
import style0 from "./CuponsList.vue?vue&type=style&index=0&id=d4a15e58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports